module.exports = __webpack_public_path__ + "static/media/217.6bff18f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/217.jpg
// module id = 959
// module chunks = 0